import { cva, type VariantProps } from "class-variance-authority";
import type * as React from "react";

import { cn } from "../utils";

const badgeVariants = cva(
  "flex-none font-semibold inline-flex items-center justify-center h-[1.875em] min-w-[1.875em] text-nowrap",
  {
    variants: {
      variant: {
        default: "bg-foreground text-background",
        primary: "bg-primary text-primary-foreground",
        secondary: "bg-foreground/7.5 text-foreground",
        destructive: "bg-destructive text-destructive-foreground",
        outline: "border border-input text-foreground",
        green: "bg-green-500 text-primary-foreground",
        amber: "bg-amber-500 text-primary-foreground",
        orange: "bg-orange-500 text-primary-foreground",
        lime: "bg-lime-500 text-primary-foreground",
      },
      size: {
        default: "text-2xs",
        xs: "text-xs",
        "2xs": "h-4 min-w-4 text-2xs",
      },
      type: {
        default: "px-[0.875em] rounded-full",
        square: "px-[0.625em] rounded",
      },
    },
    compoundVariants: [
      {
        size: "2xs",
        type: "square",
        className: "px-1!",
      },
    ],
    defaultVariants: {
      variant: "default",
      size: "default",
      type: "default",
    },
  }
);

export type BadgeProps = React.ComponentPropsWithRef<"span"> & VariantProps<typeof badgeVariants>;

function Badge({ className, variant, size, type, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant, size, type }), className)} {...props} />;
}

export { Badge, badgeVariants };
